<div class="generalPage" aria-label="help-Bookmark" role="main">
  <div class="pr-22 content-container pb-0 print-all-content">
    <h1 class="generalHeader margin-0 content-blue bold itcHeavyFont pb-heading" role="heading">{{bookmark_Header}}</h1>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="bookmark_HeaderDesc"></p>
    <p class="answer font-24 content-blue width-100 mb-invert-12 bold pb-heading" role="heading">{{bookmark_SubHeader1}}</p>
    <p class="answer font-16 content-blue width-100" [innerHTML]="bookmark_SubHeader1Body"></p>
    <p class="answer font-24 content-blue width-100 mb-invert-12 bold pb-heading" role="heading">{{bookmark_SubHeader2}}</p>
    <p class="answer font-16 content-blue width-100" [innerHTML]="bookmark_SubHeader2Body"></p>

  </div>
</div>
